import React from "react";
import styles from "./PrivacyPolicy.module.css";
import { useNavigate } from "react-router-dom";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className={styles.privacy}>
        <div className="container d-flex">
          <div className={`${styles.privacyinfo}`}>
            <div
              className={`d-flex justify-content-between ${styles.privacybutton}`}
            >
              <div className={styles.privacydiv}>Privacy Policy</div>
              <div
                onClick={() => {
                  navigate(-1);
                }}
                className={styles.button_close}
              >
                <ion-icon name="close"></ion-icon>
              </div>
            </div>
            <div className={styles.privacytext}>
              <p>MyAceショップのプライバシーポリシー 最終更新日: 2023 年 9 月 7 日 [あなたのウェブサイト名] (「当社」、「私たちの」、または「当社」) をご覧いただきありがとうございます。当社はお客様のプライバシーを保護し、お客様の個人情報が責任を持って取り扱われるよう努めます。このプライバシー ポリシーでは、お客様が当社の Web サイトまたはサービスを使用する際に、当社がお客様の個人情報をどのように収集、使用、開示、保護するかについて説明します。 当社の Web サイトにアクセスまたは使用することにより、このプライバシー ポリシーに記載されている慣行に同意したものとみなされます。このプライバシー ポリシーの条項に同意しない場合は、当社の Web サイトを使用しないでください。</p>
              <ol type="1">
                <li>
                  <p>当社が収集する情報</p>
                  <ol type="i">
                    <li>
                      <p>個人情報 当社は、以下を含むがこれらに限定されない、さまざまな種類の個人情報を収集する場合があります。 連絡先情報: 名前、電子メール アドレス、住所、電話番号など。 ユーザー アカウント データ: お客様が当社でアカウントを作成した場合、当社は、お客様のアカウントに関連するログイン認証情報およびその他の情報を収集する場合があります。 支払い情報: お客様が当社の Web サイトで購入を行う場合、当社は支払いカードの詳細またはその他の財務情報を収集する場合があります。 通信データ: サポートへの問い合わせやフィードバックなど、当社に連絡するときにお客様が提供する情報。 使用状況情報: IP アドレス、ブラウザの種類、閲覧したページなど、お客様が当社 Web サイトとどのようにやり取りしたかに関するデータ。</p>
                    </li>
                    <li>
                      <p>Cookie と追跡テクノロジー 当社は、Cookie および同様の追跡技術を使用して、当社 Web サイトでのお客様の閲覧行動に関する情報を収集する場合があります。これには、IP アドレス、ブラウザの種類、オペレーティング システムなどのデータが含まれる場合があります。 Web ブラウザの設定を通じて Cookie の設定を管理できます。</p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>お客様の情報の使用方法 当社はお客様の個人情報を次のようなさまざまな目的で使用することがあります。 サービスの提供: お客様が要求した製品またはサービスを提供するため。 ユーザー エクスペリエンスの向上: 当社の Web サイトの機能、コンテンツ、ユーザー エクスペリエンスを向上させるため。 コミュニケーション: お問い合わせに回答するため、最新情報、ニュースレター、または販促資料を送信します。 マーケティング: 当社の製品、サービス、プロモーションに関する情報を提供するため。 法的遵守: 法的義務を遵守し、当社の権利を保護します。</p>
                </li>
                <li>
                  <p>お客様の情報の開示 当社は、以下の状況において、お客様の個人情報を第三者と共有することがあります。 サービスプロバイダー: 当社は、当社のウェブサイトの運営、事業の遂行、またはお客様へのサービスを支援する信頼できるサードパーティのサービスプロバイダーと情報を共有する場合があります。 法的要件: 当社は、法的要求に応じて、または当社の権利、プライバシー、安全、財産を保護するために、法律で要求された場合に情報を開示することがあります。 事業譲渡: 当社事業の全部または一部の合併、買収、売却が発生した場合、取引の一環としてお客様の情報が移転される場合があります。 同意: 当社は、お客様の同意を得て、またはデータ収集時に開示されたとおりに、お客様の情報を共有する場合があります。</p>
                </li>
                <li>
                  <p>お客様の情報のセキュリティ 当社は、お客様の個人情報を不正なアクセス、開示、改ざん、または破壊から保護するために合理的な措置を講じます。ただし、インターネットやストレージ システムを介したデータ送信が 100% 安全であることは保証できません。当社は、お客様が当社に送信する情報の安全性を保証できません。</p>
                </li>
                <li>
                  <p>お客様の権利と選択 あなたには次の権利があります。 自分の個人情報にアクセスし、修正または削除します。 マーケティングコミュニケーションの受信をオプトアウトします。 ブラウザの設定で Cookie を無効にします。</p>
                </li>
                <li>
                  <p>本プライバシーポリシーの変更 当社は、当社の慣行や法的要件の変更を反映するために、このプライバシー ポリシーを更新することがあります。変更があった場合はこのページに掲載され、「最終更新日」の日付もそれに応じて変更されます。</p>
                </li>
                <li>
                  <p>お問い合わせ このプライバシーポリシーに関してご質問やご不明な点がございましたら、MyAce Shop までお問い合わせください。 特定の Web サイトや慣行を反映するようにプライバシー ポリシーをカスタマイズすることを忘れないでください。さらに、法律の専門家に相談して、プライバシー ポリシーが管轄区域の関連プライバシー法および規制に準拠していることを確認してください。</p>
                </li>
              </ol>  
              
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
